import { render, staticRenderFns } from "./pt-page-factor-filter.vue?vue&type=template&id=1f74a152"
import script from "./pt-page-factor-filter.vue?vue&type=script&lang=js"
export * from "./pt-page-factor-filter.vue?vue&type=script&lang=js"
import style0 from "./pt-page-factor-filter.vue?vue&type=style&index=0&id=1f74a152&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports